/**
 * Operate with navigation/breadcrumbs.
 *
 * @module breadcrumbs
 */

'use strict';

var Emitter     = require('cjs-emitter'),
    mediaTypes  = require('./types').media,
    breadcrumbs = new Emitter(),
    data        = [];


breadcrumbs.pop = function () {
    return data.pop();
};


breadcrumbs.push = function () {
    return data.push.apply(data, arguments);
};


breadcrumbs.reset = function () {
    data.length = 0;

    this.config = {
        type: mediaTypes.init.id
    };
};


Object.defineProperties(breadcrumbs, {
    path: {
        get: function () {
            var dataSpecial;

            if ( this.config.type === mediaTypes.network.id ) {
                dataSpecial = data.slice(4);
            }

            return (dataSpecial || data).reduce(function ( path, item ) {
                return path + item.path + '/';
            }, '');
        }
    },
    head: {
        get: function () {
            return data[data.length - 1];
        }
    },
    tail: {
        get: function () {
            return data[0];
        }
    },
    length: {
        get: function () {
            return data.length;
        }
    }
});


breadcrumbs.reset();


module.exports = breadcrumbs;
